// /*eslint-disable*/
export default {
  //   calledJoinNowEventScript() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       //Simple Join Now Event for fairplay
  //       joinNowEvent()
  //       const noscript = document.createElement('noscript')
  //       noscript.innerHTML = `<img height='1' width='1' style='display:none' src='https://ade.clmbtech.com/cde/eventTracking.htm?pixelId=12265&_w=1&_t=2'/>`
  //       document.body.appendChild(noscript)

  //       //Outbrain Join Now Event for fairplay
  //       outbrainJoinNowEvent()

  //       //Vortex Script on Join Now Button
  //       const Vertex = document.createElement('script')
  //       Vertex.setAttribute('src', 'https://cookie.vrtzads.com/pixel/vsync.js')
  //       Vertex.setAttribute('data-id', 'vrtzcon')
  //       Vertex.setAttribute('data-token', 'dsarqwrfdx')
  //       Vertex.setAttribute('data-vcs', '84369219453')
  //       Vertex.setAttribute(
  //         'endpoint',
  //         'https://cookie.vrtzads.com/pixel/vsync?convId=84369219453&label=Thank%20You&order_id=[ORDER_ID]&order_value=[ORDER_VALUE]&rd=[REDIRECT_URL]&email=[EMAIL]&product=[PRODUCT_ID]&cb=[CB]&u=tZkSGeUnVAl5dYb6kbHd2A&vpr=[VPR]'
  //       )
  //       document.head.appendChild(Vertex)
  //     }
  //   },
  //   quickSignUpPage() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       quickSignupFairplay()
  //     }
  //   },
  //   quickSignUpConfirmPage() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       quickSignupConfirmFairplay()
  //     }
  //   },
  //   // outbtin pixel code on quick signup start
  //   quickSignUpPageOutbrain() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       quickSignupFairplayOutbrain()
  //     }
  //   },
  //   quickSignUpConfirmPageOutbrain() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       quickSignupConfirmFairplayOutbrain()
  //     }
  //   },
  //   // outbtin pixel code on quick signup end
  //   //DIGIMAZE PIXEL CODE ON JOIN NOW BTN CLICK
  //   joinNowBtnDigimaze() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       const digimazeJoinNow = document.createElement('iframe')
  //       digimazeJoinNow.setAttribute(
  //         'src',
  //         'https://click.onatrack.in/p?o=17920601&m=3376&t=f'
  //       )
  //       digimazeJoinNow.setAttribute('width', '0px')
  //       digimazeJoinNow.setAttribute('height', '0px')
  //       document.head.appendChild(digimazeJoinNow)
  //     }
  //   },
  //   calledThankYouEventForRegistration() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       thankYouSignupEvent()
  //       const noscript = document.createElement('noscript')
  //       noscript.innerHTML = `<img height='1' width='1' style='display:none' src='https://ade.clmbtech.com/cde/eventTracking.htm?pixelId=12261&_w=1&_t=2'/>`
  //       document.body.appendChild(noscript)
  //     }
  //   },
  //   landingWhatsappEventTrigger() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       landingWhatsappEvent()
  //       const noscript = document.createElement('noscript')
  //       noscript.innerHTML = `<img height='1' width='1' style='display:none' src='https://ade.clmbtech.com/cde/eventTracking.htm?pixelId=12264&_w=1&_t=2' />`
  //       document.head.appendChild(noscript)
  //     }
  //   },
  //   calledOutbrainEventForRegistration() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       outbrainSignupEvent()
  //     }
  //   },
  //   calledoutbrainLandingPage() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       outbrainLandingPage()
  //     }
  //   },
  //   // snapchatPixelCode() {
  //   //   if (
  //   //     process.env &&
  //   //     process.env.APP_TITLE &&
  //   //     process.env.APP_TITLE === 'FairPlay' &&
  //   //     process.env.fairplayEnvironment === 'PROD'
  //   //   ) {
  //   //     const scriptSnapChat = document.createElement('script')
  //   //     scriptSnapChat.setAttribute('type', 'text/javascript')

  //   //     scriptSnapChat.innerHTML = `(function (e, t, n) {
  //   //       if (e.snaptr) return
  //   //       var a = (e.snaptr = function () {
  //   //         a.handleRequest
  //   //           ? a.handleRequest.apply(a, arguments)
  //   //           : a.queue.push(arguments)
  //   //       })
  //   //       a.queue = []
  //   //       var s = 'script'
  //   //       r = t.createElement(s)
  //   //       r.async = !0
  //   //       r.src = n
  //   //       var u = t.getElementsByTagName(s)[0]
  //   //       u.parentNode.insertBefore(r, u)
  //   //     })(window, document, 'https://sc-static.net/scevent.min.js')

  //   //     snaptr('init', '61e1bce6-db52-4b9f-a5e3-ce56c084e585', {
  //   //       user_email: '_INSERT_USER_EMAIL_'
  //   //     })

  //   //     snaptr('track', 'PAGE_VIEW')`
  //   //     document.head.appendChild(scriptSnapChat)
  //   //   }
  //   // },
  //   // VersaTAGCode(emailid) {
  //   //   if (
  //   //     process.env &&
  //   //     process.env.APP_TITLE &&
  //   //     process.env.APP_TITLE === 'FairPlay'
  //   //   ) {
  //   //     try {
  //   //       var emailSizmekEmailId = emailid
  //   //       versaTagObj.onready(function () {
  //   //         versaTagObj.clearActivityParam()
  //   //         versaTagObj.setActivityParam('loginid', emailSizmekEmailId)
  //   //         versaTagObj.generateRequest()
  //   //         versaTagObj.getActivityParam('loginid')
  //   //         // var SizmekEmailID = versaTagObj.getActivityParam('value')
  //   //       })
  //   //     } catch (err) {
  //   //       console.log(err)
  //   //     }
  //   //   }
  //   // },
  //   // sharechatRegistrationPixelCode() {
  //   //   if (
  //   //     process.env &&
  //   //     process.env.APP_TITLE &&
  //   //     process.env.APP_TITLE === 'FairPlay'
  //   //   ) {
  //   //     const urlParams = new URLSearchParams(window.location.search)
  //   //     const clickid = urlParams.get('clickid')
  //   //     if (clickid && clickid != '' && clickid != null) {
  //   //       //Sharechat Script on Registration Button
  //   //       const sharechat = document.createElement('script')
  //   //       sharechat.setAttribute(
  //   //         'src',
  //   //         'https://apis.sharechat.com/a1s-s2s-service/v1/events/fairplay/post?clickId=' +
  //   //           clickid +
  //   //           '&gaid=&campaignName=&adId=&userId=&EventTime=&eventName=registration&eventValue=1'
  //   //       )
  //   //       document.head.appendChild(sharechat)
  //   //     }
  //   //   }
  //   // },
  //   exoClick() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay'
  //     ) {
  //       const exoData = document.createElement('script')
  //       exoData.setAttribute('type', 'application/javascript')
  //       exoData.setAttribute('src', 'https://a.exoclick.com/tag_gen.js')
  //       exoData.setAttribute('data-goal', 'a97ec5c4749f9513ad54168383cdf657')
  //       document.body.appendChild(exoData)
  //     }
  //   },
  //   tracKier(userID, clickid) {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay'
  //     ) {
  //       if (userID != '' && clickid != '' && clickid != null) {
  //         const tracKier = document.createElement('script')
  //         tracKier.setAttribute(
  //           'src',
  //           'https://fairplay.trackier.co/acquisition?user_id=' +
  //             userID +
  //             '&click_id=' +
  //             clickid +
  //             '&security_token=62e548d076b3aeecc058'
  //         )
  //         document.head.appendChild(tracKier)
  //       }
  //     }
  //   },
  //   // homeschema() {
  //   //   if (
  //   //     process.env &&
  //   //     process.env.APP_TITLE &&
  //   //     process.env.APP_TITLE === 'FairPlay'
  //   //   ) {
  //   //     const homeschema = document.createElement('script')
  //   //     homeschema.setAttribute('id', 'homeschema')
  //   //     homeschema.setAttribute('type', 'application/ld+json')
  //   //     homeschema.innerHTML = `{"@context": "https://schema.org", "@type": "SportsOrganization", "name": "Fairplay", "url": "https://fairplay.club/", "logo": "https://fairplay.club/_nuxt/img/Fairplay_New_Logo.09a29c5.png"}`
  //   //     document.head.appendChild(homeschema)
  //   //   }
  //   // },
  //   faqschema() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay'
  //     ) {
  //       const faqschema = document.createElement('script')
  //       faqschema.setAttribute('id', 'faqschema')
  //       faqschema.setAttribute('type', 'application/ld+json')
  //       faqschema.innerHTML = `{"@context":"https://schema.org","@type":"FAQPage","mainEntity":[{"@type":"Question","name":"Why FairPlay?","acceptedAnswer":{"@type":"Answer","text":"FairPlay is India’s biggest and most trusted betting exchange that offers a wide range of options to bet on- from maximum sports events to live casinos and live card games. FairPlay offers the best odds in the market which ensures that a FairPlay Club member makes more profit on FairPlay than anywhere else in the market. FairPlay Club members get benefits such as: a- 100% bonus on the first deposit b- Frequent offers on deposits c- Quick payouts d- Exciting loyalty points based on player interaction e- 24/7 client support"}},{"@type":"Question","name":"What type of games does FairPlay offer?","acceptedAnswer":{"@type":"Answer","text":"a- Sportsbetting (Cricket/ Football/ Tennis/ Horse racing) b- Popular live dealer Casino games like Roulette, Baccarat, Andar Bahar, Dragon Tiger and Poker. c- Progressive slot games. d- A variety of Indian card games live such as Teenpatti, Andar Bahar, Lucky 7, 32 card poker and Amar Akbar Anthony. e- FairPlay also offers Elections stakes."}},{"@type":"Question","name":"Is FairPlay licensed and legitimate?","acceptedAnswer":{"@type":"Answer","text":"FairPlay is licensed by the authority of Curacao and is certified to operate and offer online gambling."}},{"@type":"Question","name":"What do I do if/when my game isn’t loading?","acceptedAnswer":{"@type":"Answer","text":"Clear your browser cache, cookies and restart the internet browser!"}},{"@type":"Question","name":"What is the Affiliate program and where can I find more information?","acceptedAnswer":{"@type":"Answer","text":"Head to the FairPlay Affiliate Program page for all information regarding our affiliate program and the respective persons of contact for the same."}},{"@type":"Question","name":"What happens if/ when I lose internet connectivity in the middle of a game?","acceptedAnswer":{"@type":"Answer","text":"All the rounds in all games are logged and the successful bets are still valid. Please refer to FairPlay’s disconnection policy for more information."}},{"@type":"Question","name":"An unknown error or a technical issue came up while playing. What should I do?","acceptedAnswer":{"@type":"Answer","text":"Please do not panic, contact our Client Service team and provide the following information: a- User credentials (Email ID), game details b- Approximate time when the game was played (as specific as possible) c- Stake amount and account balance before & after the game. d- Error message received/ reason given for the issue. e- A screenshot of the problem (wherever possible)"}},{"@type":"Question","name":"The video streaming is freezing, what do I do?","acceptedAnswer":{"@type":"Answer","text":"Close any other running programs. You can also try reducing the screen resolution or resizing the browser, it’s possible a low network reception could be the problem."}},{"@type":"Question","name":"The live dealer made a mistake, what now?","acceptedAnswer":{"@type":"Answer","text":"In the event of a live dealer making a mistake, the round will be temporarily paused as the dealer notifies the pit boss. The players will be notified via chatbox and if an immediate resolution is not possible, the game round in question will be canceled and a refund will be processed."}},{"@type":"Question","name":"I have a doubt, can I ask the dealers or the pit boss?","acceptedAnswer":{"@type":"Answer","text":"No! Get in touch with our Client Service team."}},{"@type":"Question","name":"Where can I find the bet limits for live casino games?","acceptedAnswer":{"@type":"Answer","text":"The minimum and maximum bet limits are displayed under every table’s name."}},{"@type":"Question","name":"How do I register?","acceptedAnswer":{"@type":"Answer","text":"a- Click on “Join Now” b- Fill out the form c- Enter the verification code you receive d- Enter your referral code e- Read and accept the terms and conditions f- Click on “Register”, congratulations you are now a FairPlay Club member!"}},{"@type":"Question","name":"I’m having trouble signing up!","acceptedAnswer":{"@type":"Answer","text":"Our system will highlight the fields that are missing. Please verify the following: a- Have you filled all the mandatory fields? b- Is your email address a valid one? c- Do you have an existing account? If you have cross-checked all of the above and still face any issue, please report it to our Client Service team."}},{"@type":"Question","name":"Forgot your password?","acceptedAnswer":{"@type":"Answer","text":"Reset your password using the “Forgot Password” function below the field. Enter your registered email address. A link to reset the password will be sent to that mailbox. Enter the code into the provided field and create a new password."}},{"@type":"Question","name":"How old do I have to be to be eligible for FairPlay Club membership?","acceptedAnswer":{"@type":"Answer","text":"18+ adults only."}},{"@type":"Question","name":"Do I need to be an Indian citizen to register on FairPlay?","acceptedAnswer":{"@type":"Answer","text":"No, you can be a FairPlay Club member from anywhere in the world."}},{"@type":"Question","name":"Can I open or operate an account for a friend or relative?","acceptedAnswer":{"@type":"Answer","text":"No. An account can and must be accessed only by one person and the login credentials must not be shared with a second person."}},{"@type":"Question","name":"I’m unable to register because it says my credentials already exist. What do I do?","acceptedAnswer":{"@type":"Answer","text":"Contact Client Services for assistance."}},{"@type":"Question","name":"Can I hold more than one account on FairPlay?","acceptedAnswer":{"@type":"Answer","text":"No. One user is only allowed one account and if found violating the same, all his accounts will be subject to suspension immediately."}},{"@type":"Question","name":"My account got locked, why and what do I do?","acceptedAnswer":{"@type":"Answer","text":"Passwords are case sensitive and after three consecutive wrong passwords, the account will get locked. Contact Client Services for resolution of the same."}},{"@type":"Question","name":"What is Sports Betting?","acceptedAnswer":{"@type":"Answer","text":"Wagering on the outcome of a sport based on logical calculations or luck, predicting sports events results is referred to as Sports Betting. You can choose from a range of sports such as cricket, football, tennis, horse racing and many more in the pipeline."}},{"@type":"Question","name":"Can I place my bets online?","acceptedAnswer":{"@type":"Answer","text":"Yes! FairPlay has brought easy, accessible sports betting within the reach of every gambling enthusiast looking for a trustworthy option to place their bets with."}},{"@type":"Question","name":"How do I place a bet?","acceptedAnswer":{"@type":"Answer","text":"a- Open the ‘Sportsbook’ tab. b- Select the game and the match. c- Click on the odd numbers corresponding to the selected outcome for that bet. d- Enter your stake. e -Double check the details before clicking on the “Place Bet” button."}},{"@type":"Question","name":"What is the meaning of Back and Lay?","acceptedAnswer":{"@type":"Answer","text":"Back is when you are betting on the team to win. A Lay bet is when you’re betting on the team to lose."}},{"@type":"Question","name":"What are the methods to deposit money on FairPlay?","acceptedAnswer":{"@type":"Answer","text":"The following methods are accepted: a- Net Banking (IMPS/ NEFT) b- Debit & credit cards c- Payment gateways d- We also offer cash transactions, please get in touch with Client Services for more details"}},{"@type":"Question","name":"What is the process of making a deposit?","acceptedAnswer":{"@type":"Answer","text":"a- Log in to your account b- Click on the ‘Wallet’ button at the top right c- Click on ‘Deposit’ e- Choose method of payment f- Enter your desired amount and a screenshot of your payment g- Submit"}},{"@type":"Question","name":"What is the minimum and maximum deposit amount?","acceptedAnswer":{"@type":"Answer","text":"Payment Gateway 500 500000 Bank Transfer 5000 500000"}},{"@type":"Question","name":"What is the maximum and minimum withdrawal amount?","acceptedAnswer":{"@type":"Answer","text":"Online Withdrawal 1000 No Limit"}},{"@type":"Question","name":"What currencies are accepted on FairPlay?","acceptedAnswer":{"@type":"Answer","text":"Mainly INR, however we do provide the facility for International debit and credit cards for overseas players along with wallets such as PayPal, Astropay etc that allow foreign currencies. We also accept cryptocurrency."}},{"@type":"Question","name":"How do I withdraw from other platforms to my Wallet?","acceptedAnswer":{"@type":"Answer","text":"Login to your FairPlay account Click on the Wallet icon on the top right Click on ‘Withdrawal’ under ‘Wallet to Platform’ Enter the amount to be withdrawn Click on submit"}},{"@type":"Question","name":"How do I withdraw my money from the FairPlay wallet?","acceptedAnswer":{"@type":"Answer","text":"Log in to your FairPlay account Click on the Wallet icon on the top right Click on ‘Withdrawal’ Choose the withdrawal method Add your bank account by clicking on “Add New” Enter the amount you wish to withdraw from your wallet Click on Submit"}},{"@type":"Question","name":"Is it safe to deposit and withdraw money to and from FairPlay?","acceptedAnswer":{"@type":"Answer","text":"Yes, it is safe because FairPlay only uses certified and secured payment methods only."}},{"@type":"Question","name":"Is there a charge on deposits or withdrawals?","acceptedAnswer":{"@type":"Answer","text":"FairPlay does not levy any fee upon the user for deposits and withdrawals."}},{"@type":"Question","name":"How can I cancel my withdrawal?","acceptedAnswer":{"@type":"Answer","text":"If you have already put in the request for a withdrawal, contact Client Services to cancel it for you."}},{"@type":"Question","name":"How long does it take to process the deposit?","acceptedAnswer":{"@type":"Answer","text":"It takes up to 1 hour for deposits to reflect in your FairPlay wallet."}},{"@type":"Question","name":"How long does it take to process a withdrawal?","acceptedAnswer":{"@type":"Answer","text":"It takes up to 12 banking hours for the withdrawal winnings to reflect in your bank account."}},{"@type":"Question","name":"Can someone make a deposit on my behalf?","acceptedAnswer":{"@type":"Answer","text":"No, FairPlay does not accept payments from a third party."}},{"@type":"Question","name":"Why was my withdrawal canceled?","acceptedAnswer":{"@type":"Answer","text":"The betting requirements were not met Withdrawal request was put in incorrectly Withdrawal was requested for a third party bank account ID verification documents were requested by FairPlay. In case of failure to provide documents within 72 hours, withdrawal requests are canceled and the said amount will be refunded to the FairPlay wallet."}},{"@type":"Question","name":"When am I eligible for a bonus?","acceptedAnswer":{"@type":"Answer","text":"A user receives a bonus only on his first deposit. In case someone signs up using his referral code, he is then eligible for the referral bonus ie 1% of each deposit the new user makes thereafter."}},{"@type":"Question","name":"When will I receive my bonus?","acceptedAnswer":{"@type":"Answer","text":"The bonus will be activated once the user completed a 20x turnover. i.e., if the bonus received is ₹1000, the user must place bets worth ₹20000 on bookmaker, sessions and casino bets and premium sportsbook. The winnings earned from the bonus received can be withdrawn but the bonus itself is for playing purposes only and cannot be withdrawn. The bonus amount received via referrals will be activated once the user completes the 20x turnover i.e., if the bonus received is ₹1000, it will be activated once the user places bets worth ₹1000x20 = ₹20000 on the bookmaker, sessions, casino bets, and premium sportsbook; irrespective of whether they’re winning or losing bets. Bonus can be canceled if turnover has not been completed."}},{"@type":"Question","name":"How long is the bonus valid for?","acceptedAnswer":{"@type":"Answer","text":"The bonus is valid for 8 weeks from the time of receival. Please complete your turnover to activate it!"}},{"@type":"Question","name":"Is FairPlay secure?","acceptedAnswer":{"@type":"Answer","text":"Yes, FairPlay is absolutely secure. It abides by strict policies meant to safeguard its players’ right to privacy. All user data is encrypted to protect the confidentiality of its users."}},{"@type":"Question","name":"Are FairPlay’s games fair?","acceptedAnswer":{"@type":"Answer","text":"Yes, FairPlay’s games and odds are transparent and fair. The odds are based on the volume of player bets. The games’ winners are announced through a certified RNG (Random Number Generator) to have a fair outcome and to rule out giving an unfair advantage to any party."}},{"@type":"Question","name":"Does FairPlay use cookies?","acceptedAnswer":{"@type":"Answer","text":"Yes, FairPlay may use cookies to provide the best gaming experience to our players."}},{"@type":"Question","name":"What is my personal information used for?","acceptedAnswer":{"@type":"Answer","text":"To create your personal FairPlay account Deposit/ withdrawal validation Identity verification process To prevent identity theft ie, to prevent third party fraud To keep you updated with latest information related to FairPlay"}}]}`
  //       document.head.appendChild(faqschema)
  //     }
  //   },
  //   facebookRegistrationTrigger() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       facebookRegistration()
  //       const noscript = document.createElement('noscript')
  //       noscript.innerHTML = `<img height="1" width="1"
  //         src="https://www.facebook.com/tr?id=281326534065770&ev=PageView
  //         &noscript=1"/>`
  //       document.head.appendChild(noscript)
  //     }
  //   },

  //   // ON SUCCESSFULLY USER REGISTRATION:
  //   digimazeFBPixelCode() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       const digimaze = document.createElement('script')
  //       digimaze.setAttribute(
  //         'src',
  //         'https://www.googletagmanager.com/gtag/js?id=AW-10893082692'
  //       )
  //       document.head.appendChild(digimaze)
  //     }
  //   },
  //   // HOME LANDING PAGE(BEFORE LOGIN):
  //   digimazePixelCodeForLandingPage() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       const pixelCode = document.createElement('script')
  //       pixelCode.setAttribute('type', 'text/javascript')

  //       pixelCode.innerHTML = `!function(_window, _document) {
  //         var OB_ADV_ID = '00d95d9f1d2ca83c0e194021e0b726810e';
  //         if (_window.obApi) {
  //           var toArray = function(object) {
  //             return Object.prototype.toString.call(object) === '[object Array]' ? object : [object];
  //           };
  //           _window.obApi.marketerId = toArray(_window.obApi.marketerId).concat(toArray(OB_ADV_ID));
  //           return;
  //         }
  //         var api = _window.obApi = function() {
  //           api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments);
  //         };
  //         api.version = '1.1';
  //         api.loaded = true;
  //         api.marketerId = OB_ADV_ID;
  //         api.queue = [];
  //         var tag = _document.createElement('script');
  //         tag.async = true;
  //         tag.src = '//amplify.outbrain.com/cp/obtp.js';
  //         tag.type = 'text/javascript';
  //         var script = _document.getElementsByTagName('script')[0];
  //         script.parentNode.insertBefore(tag, script);
  //       }(window, document);

  //       obApi('track', 'PAGE_VIEW');`
  //       document.head.appendChild(pixelCode)
  //     }
  //   },
  //   onatrackConfirmRegister() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       const pixelCode = document.createElement('img')
  //       pixelCode.setAttribute(
  //         'src',
  //         'https://click.onatrack.in/p?o=18544597&m=3376&t=i'
  //       )
  //       pixelCode.setAttribute('width', '0px')
  //       pixelCode.setAttribute('height', '0px')
  //       document.head.appendChild(pixelCode)
  //     }
  //   },
  //   onatrackQuickConfirmRegister() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       const pixelCode = document.createElement('img')
  //       pixelCode.setAttribute(
  //         'src',
  //         'https://click.onatrack.in/p?o=18557947&m=3376&t=i'
  //       )
  //       pixelCode.setAttribute('width', '0px')
  //       pixelCode.setAttribute('height', '0px')
  //       document.head.appendChild(pixelCode)
  //     }
  //   },
  //   onatrackQuickSignupConfirmRegister() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay' &&
  //       process.env.fairplayEnvironment === 'PROD'
  //     ) {
  //       const pixelCode = document.createElement('img')
  //       pixelCode.setAttribute(
  //         'src',
  //         'https://click.onatrack.in/p?o=18558308&m=3376&t=i'
  //       )
  //       pixelCode.setAttribute('width', '0px')
  //       pixelCode.setAttribute('height', '0px')
  //       document.head.appendChild(pixelCode)
  //     }
  //   },
  //   // <!-- Josh / Dailyhunt Script Code Start-->
  //   dailyHuntBtag() {
  //     if (
  //       process.env &&
  //       process.env.APP_TITLE &&
  //       process.env.APP_TITLE === 'FairPlay'
  //     ) {
  //       // dailyhunt()
  //       const add = document.createElement('script')
  //       add.innerHTML = `!(function (d, h, e, v, n, t, s) {
  //         if (d.dht) return
  //         n = d.dht = function () {
  //           n.track ? n.track.apply(n, arguments) : n.queue.push(arguments)
  //         }
  //         n.queue = []
  //         t = h.createElement(e)
  //         t.async = !0
  //         t.src = v
  //         t.id = 'dht'
  //         s = h.getElementsByTagName(e)[0]
  //         s.parentNode.insertBefore(t, s)
  //       })(
  //         window,
  //         document,
  //         'script',
  //         'https://assets-money.dailyhunt.in/dht.min.js'
  //       )
  //       dht('init', '')`
  //       document.head.appendChild(add)
  //     }
  //   },
  //   // <!-- Josh / Dailyhunt Script Code End -->

  noindexScript() {
    if (
      process.env &&
      process.env.APP_TITLE &&
      process.env.APP_TITLE === 'FairPlay'
    ) {
      const noIndex = document.createElement('meta')
      noIndex.setAttribute('name', 'robots')
      noIndex.setAttribute('content', 'noindex')
      document.head.appendChild(noIndex)
    }
  }
}
